define ['./skip_modal.scss'], () ->
  ($scope, $state, $stateParams, $rootScope, $http, RENTAPPLICATION_API_URL, $uibModalInstance) ->
    $scope.is_script_loading = false
    $scope.reason = ""
    $scope.selected_option = null
    $scope.dropdown_toggled = false
    $scope.reason_options = [
        {
          label: "No bank account",
          value: "no_bank_account"
        },
        {
          label: "Finicity does not have my bank institution as an option",
          value: "no_institution"
        },
        {
          label: "Connecting with Finicity failed",
          value: "connect_fail"
        },
        {
          label: "No income to verify",
          value: "no_income"
        },
        {
          label: "Other",
          value: "other"
        }
    ]
    $scope.other_detail = ""
    $scope.error_message = ""

    $scope.select = (choice) ->
      $scope.reason = choice.value
      $scope.selected_option = choice.label

    $scope.continue = () -> 
      $uibModalInstance.close(false)
    
    $scope.skip = () ->
      if !$scope.reason or ($scope.reason == 'other' and !$scope.other_detail)
        $scope.error_message = "Please enter required information."
        return
      $http.post("#{RENTAPPLICATION_API_URL}/api/v3/applications/#{$scope.application_id}/skip_income_verify/", {
        reason: $scope.reason,
        other_detail: $scope.other_detail
      })
      .then((resp) -> 
        $uibModalInstance.close(true)
      )


// WEBPACK FOOTER //
// ./components/applications/income/skip_modal.coffee